// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #f8f9fa;
    position: fixed;
    bottom: 0;
    left: 250px;
    right: 0;
}

footer .btn {
    width: 200px;
    font-size: 16px;
    padding: 10px;
}

footer h4 {
    font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PaymentMethods/PaymentProcess.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".footer {\n    background-color: #f8f9fa;\n    position: fixed;\n    bottom: 0;\n    left: 250px;\n    right: 0;\n}\n\nfooter .btn {\n    width: 200px;\n    font-size: 16px;\n    padding: 10px;\n}\n\nfooter h4 {\n    font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
